import { useState } from "react";
import BcMenu from "../../components/Bc-menu/Bc-menu";
import { LayoutProps } from "../../interface/props/layout";
import BcHeader from "../../components/Bc-header/BcHeader";
import BcTitleHeader from "../../components/Bc-TitleHeader/Bc-TitleHeader";
import { BcMain } from "../../styled/global.styled";
import { Role } from "../../../constants/roles";
import { useAuth } from "../../../hook/userAuth";
const LayoutMain = ({
  idPage,
  children,
  titlePage,
  requiredRoles,
}: LayoutProps) => {
  
  const authSign = useAuth(requiredRoles as string[]);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const showMenu = () => {
    setOpenMenu(!openMenu);
    console.log(openMenu);
  };

  return (
    <>
      {authSign && (
        <>
          <BcHeader onPress={showMenu} />
          <BcMenu activeMenu={openMenu}>
            {titlePage && <BcTitleHeader title={idPage} />}
            <BcMain id={idPage} title={titlePage ? "title" : ""}>
              {children}
            </BcMain>
          </BcMenu>
        </>
      )}
    </>
  );
};

export default LayoutMain;

LayoutMain.defaultProps = {
  requiredRoles: [Role.AZURE],
};
